import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter', standalone: true })
export class FilterPipe implements PipeTransform {

  transform(arr: any[], ...args: string[]): unknown {

    if (args.length === 1) {

      const value: string = args[0];
      return arr.filter(item => item?.toLowerCase().includes(value));
    } else {
      const key: string = args[0];
      const value: string = args[1];
      return arr.filter(item => item[key]?.toLowerCase().includes(value));
    }
  }

}
